import useOrganizationData from '@usas/ui-web/state/organization/UseOrganizationData';

const useQuickAddOrganizationDropdown = () => {
  const { organizationState } = useOrganizationData();

  return {
    organizationState
  };
};

export default useQuickAddOrganizationDropdown;